module.exports = __webpack_public_path__ + "static/media/social-media-svgrepo-com (2).724d5ca2.svg";